import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/** Product name of the fleet management dashboards. */
export const SPHERE_INSIGHTS_TITLE = 'Sphere Insights';

/** Bars shaded along the Sphere logo gradient (blue → purple → red → orange). */
const BAR_COLORS = ['#4a90d9', '#7b7fbe', '#9676a3', '#e25d6e', '#d98e6e'];

/** Sphere Insights logo: a bar chart drawn in the colours of the Sphere logo. */
const FleetLogo: React.FC<{ height?: number; showIcon?: boolean; showTitle?: boolean }> = ({
  height = 4,
  showIcon = false,
  showTitle = false,
}) => {
  const bars = (
    <Box
      component="svg"
      viewBox="0 0 64 40"
      role="img"
      aria-label={SPHERE_INSIGHTS_TITLE}
      data-testid="fleet-logo"
      sx={(theme) => ({
        height: {
          xs: theme.spacing(height * 0.75),
          lg: theme.spacing(height),
        },
        width: 'auto',
        display: 'block',
      })}
    >
      {BAR_COLORS.map((color, index) => {
        const barHeight = 8 + index * 7;

        return (
          <rect
            key={color}
            x={index * 13}
            y={40 - barHeight}
            width={9}
            height={barHeight}
            rx={2}
            fill={color}
          />
        );
      })}
    </Box>
  );

  if (!showTitle && showIcon) {
    return bars;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ minWidth: 0 }}>
      {showIcon && bars}
      <Typography variant="h3" fontSize={16} textTransform="none" noWrap>
        {SPHERE_INSIGHTS_TITLE}
      </Typography>
    </Stack>
  );
};

export default FleetLogo;
